module.exports = __webpack_public_path__ + "img/collection.a918f299.png";